<template>
  <div>
    <autocomplete-input :items="reportOptions.rules" :value="value.key" label="Rule" @input="onUpdate($event, 'key')" />
    <autocomplete-input
      v-if="ruleHasColumn"
      :items="columns"
      :value="value.args.column"
      label="Column"
      @input="onUpdate($event, 'args.column')"
    />
    <item-list v-if="ruleHasValues" :value="value.args.values" label="Value" @input="onUpdate($event, 'args.values')" />
    <div class="mt-4">
      <v-btn :disabled="disableConfirm" color="primary" depressed @click="onConfirm">
        Confirm
      </v-btn>
      <v-btn color="error" outlined class="ml-4" @click="onCancel">
        Cancel
      </v-btn>
    </div>
  </div>
</template>

<script>
import { set } from 'lodash-es'
import { mapGetters } from 'vuex'

import AutocompleteInput from '@/components/forms/autocomplete-input'
import ItemList from '@/components/forms/item-list'

export default {
  name: 'RuleSetter',
  components: {
    AutocompleteInput,
    ItemList,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('options', ['formattedOption', 'getItemsForOption', 'hasOptions']),
    disableConfirm() {
      return (
        !this.value?.key ||
        (this.ruleHasColumn && !this.value?.args?.column) ||
        (this.ruleHasValues && !this.value?.args?.values?.length)
      )
    },
    reportOptions() {
      return this.getItemsForOption('reports')
    },
    selectedRule() {
      return this.reportOptions.rules.find(({ value }) => value === this.value.key) || {}
    },
    ruleHasColumn() {
      return this.ruleHas(this.selectedRule, 'column')
    },
    ruleHasValues() {
      return this.ruleHas(this.selectedRule, 'values')
    },
  },
  methods: {
    formattedReportOption(key, value) {
      if (!this.reportOptions) return value
      const option = this.reportOptions[key].find(option => option.value === value)
      return option ? option.key : value
    },
    ruleHas(rule, value) {
      if (!rule.args) return false
      return !!rule.args.find(({ name }) => name === value)
    },
    onUpdate(value, key) {
      const update = set(this.value, key, value)
      this.$emit('input', update)
    },
    onCancel() {
      this.$emit('cancel')
    },
    onConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>
